/**
 * <footer> 内の SNS リンクボタンの制御
 */

/**
 * SNS リンクボタンの制御を初期化
 */
export const initSnsComponents = (): void => {
    const openExternalLink = (url: string): void => {
        window.open(url, '_blank', 'noopener,noreferrer')
    }
  // X
    const btnX = document.querySelector<HTMLElement>('#j-footer-sns-x')
    if(btnX) {
        btnX.addEventListener('click', () => {
            openExternalLink('https://twitter.com/Lion_meishi')
        })
    }
  // Facebook
    const btnFb = document.querySelector<HTMLElement>('#j-footer-sns-facebook')
    if(btnFb) {
        btnFb.addEventListener('click', () => {
            openExternalLink('https://www.facebook.com/lion.insatsu/')
        })
    }
  // instagram
    const btnInsta = document.querySelector<HTMLElement>('#j-footer-sns-insta')
    if(btnInsta) {
        btnInsta.addEventListener('click', () => {
            openExternalLink('https://www.instagram.com/lionprint__/')
        })
    }
}
